module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray@2x-be958666f6de31824e336a65e0bc00e6.png";